import axios from 'axios';
import { message } from "ant-design-vue";
const baseurl = process.env.NODE_ENV === 'development' ? 'http://49.235.207.167/index/index' : '/index/index';
axios.defaults.headers.common['header'] = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).id : ''
axios.defaults.baseURL = baseurl;
axios.interceptors.response.use(
  function (response) {
    if (response.data) {
      return response.data;
    }
  },
  function (error) {
    message.error("网络错误");
    return Promise.reject(error);
  }
);
axios.interceptors.request.use(
  function (config) {
    return config;
  },
  function (error) {
    message.error("网络错误");
    return Promise.reject(error);
  }
);

export default axios;


// WEBPACK FOOTER //
// ./src/request/request.js